// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgThreads24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M12.5293 3.00003C17.0989 3.2465 20.7478 6.81331 21 11.2803V11.7979C21.0036 13.164 20.677 14.5121 20.0469 15.7315C18.5232 18.7115 15.4081 20.5944 12 20.5957C10.6026 20.5993 9.22398 20.28 7.97659 19.6641L3.00003 21L3.95315 15.7315C3.32308 14.5121 2.99647 13.164 3.00003 11.7979C3.00148 8.46621 4.92795 5.42113 7.97659 3.93167C9.22398 3.31575 10.6026 2.99651 12 3.00003H12.5293ZM11.9961 4.50003C10.83 4.49711 9.67985 4.76333 8.63479 5.27933C6.09808 6.51876 4.50124 9.04312 4.50003 11.8018C4.4971 12.9268 4.76657 14.0374 5.28616 15.043C5.43786 15.3369 5.4876 15.6726 5.42874 15.9981L4.89749 18.9375L7.58792 18.2158C7.88954 18.1349 8.20764 18.1502 8.49808 18.2578L8.64065 18.3194C9.67999 18.8326 10.8298 19.0986 11.9991 19.0957C14.8473 19.0947 17.4461 17.5239 18.7119 15.0479C19.2343 14.0367 19.503 12.9266 19.5 11.7979L19.502 11.3653C19.2933 7.66812 16.2612 4.7035 12.5293 4.50003H11.9961Z" />
				<path d="M10 13.6135C10 13.2669 10.2844 12.9824 10.6311 12.9824H14.3289C14.6755 12.9824 14.96 13.2669 14.96 13.6135C14.96 13.9602 14.6755 14.2446 14.3289 14.2446H10.6311C10.2844 14.2446 10 13.9602 10 13.6135Z" />
				<path d="M8 10.6311C8 10.2844 8.28444 10 8.63111 10H14.3289C14.6755 10 14.96 10.2844 14.96 10.6311C14.96 10.9778 14.6755 11.2622 14.3289 11.2622H8.63111C8.28444 11.2622 8 10.9778 8 10.6311Z" />
			</Svg>
		);
	}
);
SvgThreads24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgThreads24;
